import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { QUERIES } from '@/enums/queries'
import {
  AnswerSignature,
  SaveAnswerSignatureProps,
} from '@/types/answers/answerSignature'

import { saveAnswerSignature } from './services/saveAnswerSignature'

export const useSaveAnswerSignature = (
  options?: UseMutationOptions<
    AnswerSignature,
    unknown,
    SaveAnswerSignatureProps,
    unknown
  >
) => {
  const mutation = useMutation({
    mutationKey: [QUERIES.ANSWERS.ANSWER_SIGNATURE.SAVE],
    mutationFn: saveAnswerSignature,
    ...options,
  })

  return {
    saveAnswerSignature: mutation.mutateAsync,
    ...mutation,
  }
}
